/* eslint-disable react/prop-types */
import React from 'react';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
// hooks
import { useWindowSize } from '../../../../Hooks/use-window-size';
// TODO: remove when backend will be ready
import { currencies } from '../settings';

const experienceSettings = [
  { name: '0-0', text: 'searchExperienceNoExperience' },
  { name: '1-3', text: 'searchExperienceFrom1To3Years' },
  { name: '3-6', text: 'searchExperienceFrom3To6Years' },
  { name: '6-35', text: 'searchExperienceOver6Years' },
];

const workTypeSettings = [
  { name: '1', text: 'searchWorkTypeFullTime' },
  { name: '2', text: 'searchWorkTypePartTime' },
  { name: '3', text: 'searchWorkTypeRemoteWork' },
  { name: '4', text: 'searchWorkTypeVariableSchedule' },
  { name: '5', text: 'searchWorkTypeFlexibleSchedule' },
  { name: '6', text: 'searchWorkTypeWatchMethod' },
];

const genderSettings = [
  { name: '0', text: 'searchGenderFemale' },
  { name: '1', text: 'searchGenderMale' },
];

const SelectedSearchFiltersBar = ({ setLoading, searchParams, setSearchParams }) => {
  const { width } = useWindowSize();
  const { t } = useTranslation('global');

  const handleRemoveCountryFilter = (filterKey, value, field) => {
    const updatedParams = { ...searchParams };

    if (filterKey === 'searchRegions') {
      if (field === 'country' && updatedParams[filterKey].length === 1) {
        updatedParams[filterKey] = [{ country: '', cities: [] }];
      } else if (field === 'country') {
        updatedParams[filterKey] = updatedParams[filterKey].filter(item => item !== value);
      } else if (field === 'cities') {
        updatedParams[filterKey] = updatedParams[filterKey].map(region => {
          if (region.cities.find(city => city.value === value.value)) {
            const updatedCities = region.cities.filter(city => city.value !== value.value);

            if (updatedCities.length === 0) {
              return { country: region.country, cities: [] };
            }

            return { ...region, cities: updatedCities };
          }

          return region;
        });
      }
    } else if (filterKey === 'searchCategories') {
      if (field === 'category' && updatedParams[filterKey].length === 1) {
        updatedParams[filterKey] = [{ category: '', sub_categories: [] }];
      } else if (field === 'category') {
        updatedParams[filterKey] = updatedParams[filterKey].filter(item => item !== value);
      } else if (field === 'sub_categories') {
        updatedParams[filterKey] = updatedParams[filterKey].map(category => {
          if (category.sub_categories.find(city => city.value === value.value)) {
            const updatedSubCategories = category.sub_categories.filter(subCategory => subCategory.value !== value.value);

            if (updatedSubCategories.length === 0) {
              return { category: category.category, sub_categories: [] };
            }

            return { ...category, sub_categories: updatedSubCategories };
          }

          return category;
        });
      }
    } else if (filterKey === 'searchLanguages') {
      if (field === 'lng' && updatedParams[filterKey].length === 1) {
        updatedParams[filterKey] = [{ lng: null, lng_skill: null }];
      } else if (field === 'lng') {
        updatedParams[filterKey] = updatedParams[filterKey].filter(item => item.lng !== value);
      } else if (field === 'lng_skill') {
        updatedParams[filterKey] = updatedParams[filterKey].map(language => {
          if (language.lng_skill && language.lng_skill.value === value.value) {
            return { ...language, lng_skill: null };
          }

          return language;
        });
      }
    }

    setSearchParams(updatedParams);
  };

  const handleRemoveFilter = (filterKey, value) => {
    const updatedParams = { ...searchParams };

    if (Array.isArray(updatedParams[filterKey])) {
      updatedParams[filterKey] = updatedParams[filterKey].filter(item => item !== value);
    } else {
      updatedParams[filterKey] = '';
    }

    if (filterKey === 'searchDriverLicense') {
      updatedParams.searchDriverCategories = [];
    }

    setSearchParams(updatedParams);
  };

  const handleResetFilters = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('jobseekerListing.no'),
        confirmButtonText: t('jobseekerListing.yes'),
        title: t('jobseekerListing.resetFiltersTitle'),
      });

      if (confirmationResult.isConfirmed) {
        setLoading(true);

        await new Promise(resolve => setTimeout(resolve, 0));

        setSearchParams(prev => ({
          ...prev,
          searchAgeTo: '',
          searchGender: [],
          searchAgeFrom: '',
          searchLocation: [],
          searchLogic: 'all',
          searchIndustry: [],
          searchSalaryTo: '',
          searchWorkType: [],
          searchEducation: [],
          searchExperience: [],
          searchSalaryFrom: '',
          searchPlace: ['titles'],
          searchSalaryCurrency: '',
          searchDriverCategories: [],
          searchDriverLicense: false,
          searchRegions: [{ country: null, cities: [] }],
          searchLanguages: [{ lng: null, lng_skill: null }],
          searchCategories: [{ category: null, sub_categories: [] }],
        }));
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error('Error resetting filters:', error);
    }
  };

  const FilterTag = ({ label, title, filterKey, value, field }) => {
    const handleRemove = () => {
      if (filterKey === 'searchRegions') {
        if (field === 'country') {
          handleRemoveCountryFilter(filterKey, value, 'country');
        } else if (field === 'cities') {
          handleRemoveCountryFilter(filterKey, value, 'cities');
        }
      } else if (filterKey === 'searchCategories') {
        if (field === 'category') {
          handleRemoveCountryFilter(filterKey, value, 'category');
        } else if (field === 'sub_categories') {
          handleRemoveCountryFilter(filterKey, value, 'sub_categories');
        }
      } else if (filterKey === 'searchLanguages') {
        if (field === 'lng') {
          handleRemoveCountryFilter(filterKey, value, 'lng');
        } else if (field === 'lng_skill') {
          handleRemoveCountryFilter(filterKey, value, 'lng_skill');
        }
      } else {
        handleRemoveFilter(filterKey, value);
      }
    };

    return (
      <div className='filterTag' key={label}>
        <p title={title}>
          {label}
        </p>
        <button onClick={handleRemove}>
          <i className='fa-solid fa-xmark' />
        </button>
      </div>
    );
  };

  const getSelectedFilters = () => {
    let filters = [];

    if (searchParams.searchRegions.length) {
      filters = filters.concat(searchParams.searchRegions
        .filter(region => region?.country)
        .map(region =>
          <FilterTag
            value={region}
            field='country'
            filterKey='searchRegions'
            label={region.country.label}
            key={`searchRegions_country_${region.country.value}`}
          />,
        ));
    }
    if (searchParams.searchRegions.length) {
      filters = filters.concat(searchParams.searchRegions
        .filter(region => region?.cities?.length > 0)
        .map(region => region.cities.map(city => (
          <FilterTag
            value={city}
            field='cities'
            filterKey='searchRegions'
            label={city.label.split(',')[0]}
            key={`searchRegions_city_${city.value}`}
          />
        )))
        .flat(),
      );
    }
    if (searchParams.searchCategories.length) {
      filters = filters.concat(searchParams.searchCategories
        .filter(category => category?.category)
        .map(category =>
          <FilterTag
            field='category'
            value={category}
            filterKey='searchCategories'
            label={category.category.label}
            key={`searchCategories_category_${category.category.value}`}
          />,
        ));
    }
    if (searchParams.searchCategories.length) {
      filters = filters.concat(searchParams.searchCategories
        .filter(category => category?.sub_categories?.length > 0)
        .map(category => category.sub_categories.map(subCategory => (
          <FilterTag
            value={subCategory}
            field='sub_categories'
            filterKey='searchCategories'
            key={`search_sub_categories_${subCategory.value}`}
            label={subCategory.label.length > 30 ? `${subCategory.label.slice(0, 30)}...` : subCategory.label}
          />
        )))
        .flat(),
      );
    }
    if (searchParams.searchSalaryFrom) {
      filters.push(<FilterTag label={`Зарплата від: ${searchParams.searchSalaryFrom}`} filterKey='searchSalaryFrom' value={searchParams.searchSalaryFrom} />);
    }
    if (searchParams.searchSalaryTo) {
      filters.push(<FilterTag label={`Зарплата до: ${searchParams.searchSalaryTo}`} filterKey='searchSalaryTo' value={searchParams.searchSalaryTo} />);
    }
    if (searchParams.searchSalaryCurrency && (searchParams.searchSalaryFrom || searchParams.searchSalaryTo)) {
      filters.push(
        <FilterTag
          filterKey='searchSalaryCurrency'
          value={searchParams.searchSalaryCurrency}
          label={`Валюта: ${currencies[searchParams.searchSalaryCurrency]}`}
        />);
    }
    if (searchParams.searchExperience.length) {
      filters = filters.concat(searchParams.searchExperience.map(exp =>
        <FilterTag
          value={exp}
          filterKey='searchExperience'
          key={`searchExperience_${exp}`}
          label={t(`jobseekerListing.${experienceSettings.find(i => i.name === exp)?.text}`)}
        />));
    }
    if (searchParams.searchIndustry.length) {
      filters = filters.concat(searchParams.searchIndustry.map(i =>
        <FilterTag
          value={i}
          title={i.label}
          filterKey='searchIndustry'
          key={`searchIndustry_${i.value}`}
          label={i.label.length > 30 ? `${i.label.slice(0, 30)}...` : i.label}
        />));
    }
    if (searchParams.searchWorkType.length) {
      filters = filters.concat(searchParams.searchWorkType.map(workType =>
        <FilterTag
          value={workType}
          filterKey='searchWorkType'
          key={`searchWorkType_${workType}`}
          label={t(`jobseekerListing.${workTypeSettings.find(i => i.name === workType)?.text}`)}
        />));
    }
    if (searchParams.searchEducation.length) {
      filters = filters.concat(searchParams.searchEducation.map(edu =>
        <FilterTag
          value={edu}
          label={edu.label}
          filterKey='searchEducation'
          key={`searchEducation_${edu.value}`}
        />));
    }
    if (searchParams.searchLanguages.length) {
      filters = filters.concat(searchParams.searchLanguages
        .filter(lng => lng?.lng)
        .map(lng =>
          <FilterTag
            field='lng'
            value={lng.lng}
            label={lng.lng.label}
            filterKey='searchLanguages'
            key={`searchLanguages_${lng.lng.value}`}
          />,
        ));
    }
    if (searchParams.searchLanguages.length) {
      filters = filters.concat(searchParams.searchLanguages
        .filter(lng => lng?.lng_skill)
        .map((lng, index) =>
          <FilterTag
            field='lng_skill'
            value={lng.lng_skill}
            label={lng.lng_skill.label}
            filterKey='searchLanguages'
            key={`searchLanguages_${lng.lng_skill.value}_${index}`}
          />,
        ));
    }
    if (searchParams.searchAgeFrom) {
      filters.push(<FilterTag label={`Вік від ${searchParams.searchAgeFrom}`} filterKey='searchAgeFrom' value={searchParams.searchAgeFrom} />);
    }
    if (searchParams.searchAgeTo) {
      filters.push(<FilterTag label={`Вік до ${searchParams.searchAgeTo}`} filterKey='searchAgeTo' value={searchParams.searchAgeTo} />);
    }
    if (searchParams.searchGender.length) {
      filters = filters.concat(searchParams.searchGender.map(gender =>
        <FilterTag
          value={gender}
          filterKey='searchGender'
          key={`searchGender_${gender}`}
          label={t(`jobseekerListing.${genderSettings.find(i => i.name === gender)?.text}`)}
        />));
    }
    if (searchParams.searchDriverLicense) {
      filters.push(<FilterTag label={t('jobseekerListing.driverLicense')} filterKey='searchDriverLicense' value={searchParams.searchDriverLicense} />);
    }
    if (searchParams.searchDriverCategories.length) {
      filters = filters.concat(searchParams.searchDriverCategories.map(i =>
        <FilterTag
          value={i}
          title={i.label}
          filterKey='searchDriverCategories'
          key={`searchDriverCategories_${i.value}`}
          label={i.label.length > 30 ? `${i.label.slice(0, 30)}...` : i.label}
        />));
    }

    return filters;
  };

  const selectedFilters = getSelectedFilters();

  return width >= 992 && selectedFilters.length > 0 && (
    <div className='selectedSearchFiltersBar'>
      {selectedFilters}
      {selectedFilters.length > 0 && (
        <div className='advancedSearchButtons'>
          <button
            type='button'
            onClick={() => handleResetFilters()}
          >
            <i className='fa-solid fa-arrows-rotate' />
            {t('jobseekerListing.resetFilters')}
          </button>
        </div>
      )}
    </div>
  );
};

export default SelectedSearchFiltersBar;
